import { Snapshot } from 'types';
import { CleanedSnapshot } from '../features/snapshotExport/types';

export const cleanSnapshotSettings = (snapshot: Snapshot): CleanedSnapshot => {
  const {
    id,
    last_trace,
    last_updated,
    baseline_trace,
    max_trace,
    min_trace,
    ...snapshotCopy
  } = snapshot;
  return snapshotCopy;
};
